module.exports = __webpack_public_path__ + "img/partner5.d4eda5c5.png";